<template>
  <v-btn
    text
    tile
    large
    color="primary"
    class="non-text-transformation link px-0"
    :disabled="disabled"
    @click="handleClick"
  >
    {{ $t('STEPPER_BUTTON_BEFORE') }}
  </v-btn>
</template>

<script>
export default {
  name: 'PrevButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>
